import { useKeycloak } from '@react-keycloak/web';
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { clear as clearStorage } from 'idb-keyval';
import PropTypes from 'prop-types';

import { SDPContext } from 'Contexts';
import { Mixpanel, trackingMessages } from 'Services';

import useRoutes from 'Routes/useRoutes';

import { Sidebar } from 'Components';

export default function Authorized({ children }) {
  const { keycloak } = useKeycloak();
  const history = useHistory();
  const { navigation, setCurrentCompany, setRole } = useRoutes();
  const sidebarFooterActions = [
    {
      name: 'Manager',
      callback: () => history.push('/manager/users')
    },
    {
      name: 'Support',
      callback: () => history.push('/support')
    },
    {
      name: 'Logout',
      callback: () => {
        clearStorage();
        localStorage.clear();
        Mixpanel.track(trackingMessages.log_out);
        keycloak.logout({
          redirectUri: `${window.location.origin}/login`
        });
      }
    }
  ];

  const {
    state: {
      company: {
        data: { current: currentCompany }
      },
      user: { data: sessionUser }
    }
  } = useContext(SDPContext);

  useEffect(() => {
    if (currentCompany && sessionUser) {
      setCurrentCompany(currentCompany);
      setRole(sessionUser);
    }
  }, [currentCompany, sessionUser, setCurrentCompany, setRole]);

  return (
    <div className="sdp-page-wrapper">
      <Sidebar
        navigation={navigation}
        open
        dropDir="right"
        actions={sidebarFooterActions}
        user={sessionUser}
      />
      <main className="sdp-main">{children}</main>
    </div>
  );
}

Authorized.propTypes = {
  children: PropTypes.node.isRequired
};
